/**
 * @file apps/web/src/lib/formatTimestamp.ts
 * @description Formats a position in a recording ("seconds in") as m:ss, or
 * h:mm:ss from one hour up. Accepts what the API actually sends: Postgres
 * NUMERIC columns arrive as strings ("754.50"), so a string is parsed first.
 * Returns null for anything that isn't a finite, non-negative number — callers
 * show nothing rather than "NaN:NaN".
 */

export function formatTimestamp(value: number | string | null | undefined): string | null {
  if (value === null || value === undefined || value === '') return null;
  const secs = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(secs) || secs < 0) return null;

  const total = Math.floor(secs);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const ss = String(s).padStart(2, '0');
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
}
